export default __webpack_public_path__ + "static/media/03.47df360f.jpg";